<template>
  <div>
    <div class="ui-text-m text-white font-medium mb-4 max-lg:text-center">
      {{ footerFormData.title }}
    </div>
    <div class="relative">
      <form
        class="flex items-start"
        :class="{ 'opacity-0': emailSend }"
        @submit.prevent="onSubmit"
      >
        <UiInput
          id="signUpForSpecialOffers"
          v-model="userEmail"
          class="w-full"
          input-classes="bg-transparent !placeholder-white"
          name="email"
          color="white"
          :hide-details="false"
          :placeholder="footerFormData.inputPlaceholder"
        />
        <UiButton
          :loading="loadingEmail"
          type="submit"
          color="white"
          variant="default"
          class="min-w-11 min-h-11 size-11"
          variant-type="icon"
        >
          <UiIcon name="email" class="size-4.5" />
        </UiButton>
      </form>
      <div
        v-if="emailSend"
        class="flex items-center ui-text-m text-white h-11 absolute left-0 top-0"
      >
        <img
          src="/images/email-checkmark.png"
          :alt="footerFormData.successMessage"
          class="size-7.5 mr-2"
        />
        {{ footerFormData.successMessage }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { object, string } from "yup";
import { useForm } from "vee-validate";
import { FetchError } from "ofetch";
import { useGeneralInternalStore } from "~/stores/generalInternal";

interface InitialForms {
  email: string;
}

const { $api } = useNuxtApp();
const { t } = useI18n();
const route = useRoute();
const { footer } = useGeneralInternalStore();

const userEmail = ref("");
const emailSend = ref(false);
const loadingEmail = ref<boolean>(false);

const initialForm: InitialForms = {
  email: "",
};

const { generateLeadEvent } = useEvents();

const schema = object().shape({
  email: string().email().required().label(t("email")),
});

const formValues = reactive(
  JSON.parse(JSON.stringify(initialForm)),
) as InitialForms;

const { handleSubmit, resetForm, setErrors, errors } = useForm({
  initialValues: formValues,
  validationSchema: schema,
});

const footerFormData = computed(() => {
  return {
    title: footer.footerForm?.title || t("deliveringGemsToYourInbox"),
    subTitle: footer.footerForm?.subTitle || "",
    buttonText: footer.footerForm?.buttonText || t("subscribe"),
    successMessage:
      footer.footerForm?.successMessage || t("thanksYouAreOnTheList"),
    inputPlaceholder:
      footer.footerForm?.inputPlaceholder || t("enterYourEmail"),
  };
});

watch(
  () => route.fullPath,
  () => {
    emailSend.value = false;
  },
);

watch(
  errors,
  (val) => {
    if (val.email) {
      emailSend.value = false;
    }
  },
  { deep: true },
);

const onSubmit = handleSubmit(async (values) => {
  loadingEmail.value = true;
  try {
    await $api.general.subscribe(values);
    emailSend.value = true;
    userEmail.value = "";
    generateLeadEvent("subscribe");
    resetForm();
    setTimeout(() => {
      emailSend.value = false;
    }, 5000);
  } catch (error) {
    console.error(error);
    if (error instanceof FetchError) {
      setErrors(responseErrorToObjectErrors(error?.data?.errors));
    }
  } finally {
    loadingEmail.value = false;
  }
});
</script>
